module.exports = __webpack_public_path__ + "static/media/book.416b538d.svg";